<template lang="pug">
StatusChip(:status="status" :text-tooltip="textTooltip")
  template(#tooltip v-if="isRejected")
    div.statement-rejection-comment.mt-2
      span.b-600 {{ $t('rejectReason') }}:
      span.ml-1(v-if="comment") {{ comment }}
      span.ml-1(v-else) {{ $t('rejectReasonMissing') }}
</template>

<script>
import statuses, { list as statusesList } from '@/configs/statuses'

export default {
  name: 'StatementStatus',
  props: {
    statement: { type: Object, required: true },
    textTooltip: { type: Boolean, default: false }
  },
  computed: {
    status () {
      return statuses.statement(this.statement.status_document)
    },
    isRejected () {
      return this.statement.status_document === statusesList.statementReject
    },
    comment () {
      return this.statement.statement_decision?.comment || ''
    }
  }
}
</script>

<style lang="sass" scoped>
.statement-rejection-comment
  white-space: pre-wrap
  overflow-wrap: anywhere
</style>
